import type { AxiosInstance } from "axios";

export type LogAcessoRequest = {
  nomeSolucao?: string;
  pagina: string;
};

export type LogAcessoResponse = {
  sucesso?: boolean;
  mensagem?: string;
};

export interface LogAcessoApi {
  registrarAcesso(body: LogAcessoRequest): Promise<LogAcessoResponse>;
}

export function buildLogAcessoApi(api: AxiosInstance): LogAcessoApi {
  return {
    registrarAcesso: async (body) => {
      const { data } = await api.post<LogAcessoResponse>("/access", body);
      return data;
    },
  };
}
